import { useCallback, useEffect } from 'react';

const getPos = (dom: HTMLElement | Element | null) => {
	const { top, left } = dom ? dom.getBoundingClientRect() : { top: 0, left: 0 };
	return {
		top: `${top}px`,
		left: `${left}px`
	};
};

type GetTheme = () => string;

/**
 * When DnD, CraftJs is cloning the dragged node, append it to the body, and taking a snapshot of it
 * The selected theme is applied in the editor level
 * In order for the dragged element to have the current selected theme, we should add the "data-theme" attribute to it when dragging, and remove it when dropping
 * This fn handles it
 */
export const useThemeInDndShadow = (
	observeEle: HTMLElement | null,
	getTheme: GetTheme
) => {
	const onDragStart = useCallback(
		(e: DragEvent) => {
			const dataTheme = getTheme();
			const ele = e.currentTarget as HTMLElement;
			ele?.setAttribute('data-theme', dataTheme);
			ele?.addEventListener(
				'dragend',
				() => ele?.removeAttribute('data-theme'),
				{ capture: true, once: true }
			);
		},
		[getTheme]
	);

	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (observeEle) {
			observeEle.addEventListener('dragstart', onDragStart, { capture: true });

			return () => {
				observeEle.removeEventListener('dragstart', onDragStart);
			};
		}
	}, [observeEle, onDragStart]);
};

export { getPos };

export const isMouseInsideElement = (
	ele: HTMLElement,
	clientX: number,
	clientY: number
) => {
	const rect = ele.getBoundingClientRect();

	return (
		clientX >= rect.left &&
		clientX <= rect.right &&
		clientY >= rect.top &&
		clientY <= rect.bottom
	);
};
